import FirebaseAuthService from './FirebaseAuthService.js';

export default FirebaseAuthService;
